enum ScheduleDueDatesType {
    Interval = "INTERVAL",
    FixedDaysOfMonth = "FIXED_DAYS_OF_MONTH"
}
export default ScheduleDueDatesType